import { render, staticRenderFns } from "./onboarding-step-1.vue?vue&type=template&id=da33e8a4&scoped=true"
import script from "./onboarding-step-1.vue?vue&type=script&lang=js"
export * from "./onboarding-step-1.vue?vue&type=script&lang=js"
import style0 from "./onboarding-step-1.vue?vue&type=style&index=0&id=da33e8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da33e8a4",
  null
  
)

export default component.exports